// This is the standard web chat configuration object. You can modify these values with the embed code for your
// own assistant if you wish to try this example with your assistant. You can find the documentation for this at
// https://web-chat.global.assistant.watson.cloud.ibm.com/docs.html?to=api-configuration#configurationobject.

// integrationID is the watsonx Assistant integration id found from the web credentials
// region is the region where watsonx assistant is hosted
// serviceInstanceID is from the URL once the service is deployed
// subscriptionID is left as null unless requried

/**
 *
 * JMV TEST
 * integrationID: "9a60ecc8-1191-404d-87b0-fd37e1d80b8b", // The ID of this integration.
 *   region: "wxo-ca-tor", // The region your integration is hosted in.
 *   serviceInstanceID: "020f84d4-ede9-4b68-8895-c7372f3f4cb4", // The ID of your service instance.
 *
 */

const config = {
  // integrationID: 'a06b605f-4f78-4585-9f65-337c602fef9d', //draft - dev
  // integrationID: '53cd01ed-34fc-4baf-97c7-81c72f9118bc', //live - staging / production

  // integrationID: '9a60ecc8-1191-404d-87b0-fd37e1d80b8b', //draft - dev JMV TEST
  integrationID: 'f50738e8-a62a-4aaa-a1bf-bbe17c4ca429', //draft - staging JMV TEST
  serviceInstanceID: '020f84d4-ede9-4b68-8895-c7372f3f4cb4',

  region: 'wxo-ca-tor',
  subscriptionID: null,
}

// Known vehicle types - Update to relevant year when url known
const VEHICLE_TYPES = {
  OUTLANDER: {
    key: 'outlander',
    index: 'outlander',
    name: 'outlander',
  },
  OUTLANDER_2025: {
    key: 'outlander-2025',
    index: 'outlander-2025',
    name: 'outlander 2025',
  },
  ECLIPSE: {
    key: 'eclipse-cross',
    index: 'eclipse-cross',
    name: 'eclipse-cross',
  },
  RVR: {
    key: 'rvr',
    index: 'rvr',
    name: 'rvr',
  },
}

// included url examples
// - /en/vehicles/eclipse-cross
// - /en/vehicles/eclipse-cross/123
// - /fr/vehicules/eclipse-cross
// - /fr/vehicules/eclipse-cross/123
// excluded url examples
// - /en/vehicles/eclipse-cross-2025
// - /fr/vehicules/eclipse-cross-2025
// - /en/vehicles/eclipse-cross-2025/123
// - /fr/vehicules/eclipse-cross-2025/123

// URL configuration for determining vehicle context
const VEHICLE_URL_CONFIG = [
  {
    urls: {
      includes: [
        `/en/vehicles/${VEHICLE_TYPES.OUTLANDER.key}`,
        `/fr/vehicules/${VEHICLE_TYPES.OUTLANDER.key}`,
      ],
      excludes: [
        `/en/vehicles/${VEHICLE_TYPES.OUTLANDER_2025.key}`,
        `/fr/vehicules/${VEHICLE_TYPES.OUTLANDER_2025.key}`,
      ],
    },
    vehicleType: VEHICLE_TYPES.OUTLANDER.index,
  },
  {
    urls: {
      includes: [
        `/en/vehicles/${VEHICLE_TYPES.OUTLANDER_2025.key}`,
        `/fr/vehicules/${VEHICLE_TYPES.OUTLANDER_2025.key}`,
      ],
      excludes: [
        `/en/vehicles/${VEHICLE_TYPES.OUTLANDER.key}/`,
        `/fr/vehicules/${VEHICLE_TYPES.OUTLANDER.key}/`,
      ],
    },
    vehicleType: VEHICLE_TYPES.OUTLANDER_2025.index,
  },
  {
    urls: {
      includes: [
        `/en/vehicles/${VEHICLE_TYPES.ECLIPSE.key}`,
        `/fr/vehicules/${VEHICLE_TYPES.ECLIPSE.key}`,
      ],
      excludes: [
        `/en/vehicles/${VEHICLE_TYPES.ECLIPSE.key}-2025`,
        `/fr/vehicules/${VEHICLE_TYPES.ECLIPSE.key}-2025`,
      ],
    },
    vehicleType: VEHICLE_TYPES.ECLIPSE.index,
  },
  {
    urls: {
      includes: [`/en/vehicles/${VEHICLE_TYPES.RVR.key}`, `/fr/vehicules/${VEHICLE_TYPES.RVR.key}`],
      excludes: [
        `/en/vehicles/${VEHICLE_TYPES.RVR.key}-2025`,
        `/fr/vehicules/${VEHICLE_TYPES.RVR.key}-2025`,
      ],
    },
    vehicleType: VEHICLE_TYPES.RVR.index,
  },
]

export { config, VEHICLE_TYPES, VEHICLE_URL_CONFIG }
